function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiners = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 104 82",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M60.87 81.93c22.38.11 42.81-18.25 42.81-40.58 0-24.42-20.43-41.3-42.81-41.29H41.61C18.96.06.32 16.94.32 41.36c0 22.34 18.64 40.69 41.29 40.58h19.26z",
  style: {
    fill: "#004a98"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.2 63.1V18.76c8.91 3.42 15.24 12.05 15.26 22.17-.02 10.12-6.34 18.74-15.26 22.17M17.95 40.93c.02-10.12 6.34-18.74 15.25-22.17v44.33c-8.91-3.43-15.23-12.05-15.25-22.16M41.7 3.45C21.01 3.46 4.24 20.23 4.23 40.93 4.23 61.63 21 78.39 41.7 78.4c20.7-.01 37.47-16.78 37.47-37.47 0-20.7-16.77-37.47-37.47-37.48",
  style: {
    fill: "#fff"
  }
}));
export default SvgDiners;